import {
  activateVideoCallPrivacy,
  isVideoCallRoutePath,
  type VideoCallPrivacyWindow,
} from "~/utils/videoCalls/privacy";
import {
  getVideoCallInvitationCodeFromPath,
  isVideoCallShortRoutePath,
} from "~/utils/videoCalls/invitation";
import {
  captureVideoCallToken,
  hasStoredVideoCallGuestBackgroundSession,
  VIDEO_CALL_TOKEN_CAPTURED_EVENT,
} from "~/utils/videoCalls/session";

const readToken = (hash: string): string => {
  const rawHash = hash.replace(/^#/, "");
  const params = new URLSearchParams(rawHash);
  const parameterToken = params.get("token");
  return parameterToken === null ? rawHash : parameterToken;
};

export default defineNuxtPlugin({
  name: "video-call-privacy-preflight",
  enforce: "pre",
  setup() {
    const router = useRouter();
    const privacyTarget = window as unknown as VideoCallPrivacyWindow;

    if (hasStoredVideoCallGuestBackgroundSession()) {
      activateVideoCallPrivacy(privacyTarget);
    }

    router.beforeEach((to) => {
      if (!isVideoCallRoutePath(to.path)) {
        return;
      }

      activateVideoCallPrivacy(privacyTarget);

      if (isVideoCallShortRoutePath(to.path)) {
        const token = getVideoCallInvitationCodeFromPath(to.path);
        captureVideoCallToken(token ?? "", { invalid: token === null });
        window.dispatchEvent(new Event(VIDEO_CALL_TOKEN_CAPTURED_EVENT));

        return {
          path: "/video-call",
          query: to.query,
          hash: "",
          replace: true,
        };
      }

      if (!to.hash) {
        return;
      }

      const token = readToken(to.hash);
      if (token) {
        captureVideoCallToken(token);
        window.dispatchEvent(new Event(VIDEO_CALL_TOKEN_CAPTURED_EVENT));
      }

      return {
        path: to.path,
        query: to.query,
        hash: "",
        replace: true,
      };
    });
  },
});
